var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckmark = function SvgCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.377.273a.957.957 0 0 1 1.349.01.944.944 0 0 1 .007 1.323l-.017.017L6.542 14.527a.96.96 0 0 1-1.327.012l-.017-.017L.28 9.633a.944.944 0 0 1 0-1.34.96.96 0 0 1 1.331-.017l.018.017 4.25 4.224z"
  })));
};
export default SvgCheckmark;